import React from 'react';
import PropTypes from 'prop-types';
import {withStyles} from 'material-ui/styles';
import Layout from '../../components/main/layout/layout';
import styles from './styles';

function isApplicationRedirect() {
	return window.location.search.substr(1).includes('app=true');
}

const Terms = props => {
	const {classes, history} = props;
	const isRedirect = isApplicationRedirect();

	return (
		<Layout
			title={<div>TERMS AND CONDITIONS OF USE</div>}
			hideHeaderControls={isRedirect}
			handleGoBack={() => {
				if (history.length <= 2) {
					history.push('/');
				} else {
					history.goBack();
				}
			}}
			isHomepage={false}
		>
			<div className={classes.container}>
				<h1 className={classes.title}>JUVORA&#8482; GUIDE APP TERMS AND CONDITIONS OF USE</h1>
				<h2>PLEASE READ THESE LICENCE TERMS CAREFULLY</h2>
				<p>Welcome to the JUVORA&#8482; Guide App which provides you with access to information for
				education and training purposes on how to use and process Juvora products. The
				JUVORA&#8482; Guide is made available to you by Juvora Limited (an Invibio company). These
				Terms of Use (<b>Terms</b>) have legal effect between us.
				</p>
				<h3>Statutory Information</h3>
				<ul>
					<li>Juvora Limited (Juvora or We or Us)</li>
					<li>Registered in England and Wales</li>
					<li>Company number 8149439</li>
					<li>Registered office is at Victrex Technology Centre, Hillhouse International, Thornton
					Cleveleys, Lancashire FY5 4QD.
					</li>
					<li>VAT number: GB604 782539</li>
				</ul>
				<h3>Other Applicable Terms</h3>
				<p>By downloading or otherwise accessing the JUVORA&#8482; Guide App, you agree to be bound
				by these Terms. Our JUVORA&#8482; Guide App Privacy & Cookies Policy will also apply. If
				you do not agree with these Terms, you should stop using the JUVORA&#8482; Guide App
				immediately.
				</p>
				<h3>Copyright</h3>
				<p>All content published on the JUVORA&#8482; Guide App is &copy;2018 Juvora Limited and its
				licensors. All rights reserved. You must obtain prior written permission for the
				republication or redistribution of any content, except where allowed by these Terms.
				</p>
				<h3>Trade Marks</h3>
				<p>JUVORA&#8482;, INVIBIO&#8482;, PEEK-OPTIMA&#8482;, INVIBIO BIOMATERIAL SOLUTIONS&#8482; are
				registered or unregistered trade marks of Victrex plc or its group companies.
				</p>
				<h3>Scope</h3>
				As allowed by these Terms, we license you to use:
				<ul>
					<li>JUVORA&#8482; Guide app mobile application software, the data supplied with the
					software, (JUVORA&#8482; Guide App) and any updates or supplements to it.
					</li>
					<li>The related online electronic documentation (Documentation).</li>
					<li>The service you connect to via the JUVORA&#8482; Guide App and the content we provide
					to you through it (Service).
					</li>
				</ul>
				<h3>Your Privacy</h3>
				<p>We only use any personal data we collect through your use of the JUVORA&#8482; Guide App
				and the Services in the ways set out in our JUVORA&#8482; Guide App Privacy & Cookies
				Policy. Please be aware that internet transmissions are never completely private or secure
				and that any message or information you send using the JUVORA&#8482; Guide App or any
				Service may be read or intercepted by others, even if there is a special notice that a
				particular transmission is encrypted.
				</p>
				<h3>Terms of mobile application stores may also apply</h3>
				<p>The ways in which you can use the JUVORA&#8482; Guide App and Documentation may also
				be controlled by the rules and policies of mobile application stores.
				</p>
				<h3>Operating System Requirements</h3>
				<p>We test the JUVORA&#8482; Guide App on the most popular browsers and devices currently
				being used to access our service.
				</p>
				<p>The following browsers and devices have been tested to work with the JUVORA&#8482; Guide
				App.
				</p>
				<p>Google Chrome (Latest Version)<br/>
				Microsoft Internet Explorer 11 and above<br/>
				Microsoft Edge<br/>
				Mozilla Firefox (Latest Version)<br/>
				Opera (Latest Version)<br/>
				Safari (Latest Version)<br/><br/>
				Android 7.0 and above<br/>
				iOS 10.0 and above
				</p>
				<h3>Contacts</h3>
				<p>If you have any queries about the JUVORA&#8482; Guide App or these Terms, or experience
				any problems using the JUVORA&#8482; Guide App or want to report a problem, please click
				on the “Contact Us” button on the JUVORA&#8482; Guide App. If we have to contact you, we
				will do so by email.
				</p>
				<h3>How you may use the JUVORA&#8482; Guide App</h3>
				In return for your agreeing to comply with these Terms, you may view, listen to, use and
				display the JUVORA&#8482; Guide App, the Documentation and the Service only in the
				ordinary course of your organisation’s business, only for your personal and internal use,
				only for education and training purposes relating to the use and processing of JUVORA
				products and may also:
				<ul>
					<li>download or stream a copy of the JUVORA</li>
				TM Guide App onto mobile telephone,
				handheld devices, laptop and desktop computers;
					<li>print any Documentation accessed via the JUVORA&#8482; Guide App provided such
				printing is not substantial or systematic and our trademarks, and trademark and
				copyright notices are not removed;
					</li>
					<li>share the Documentation with your customers and other third parties outside your
				organisation provided you are sure that the recipient will not use the Documentation
				you send to create competitor products or their own works, products or services;
					</li>
					<li>receive and use any free supplementary software code or update of the JUVORA&#8482;
				Guide App incorporating &quot;patches&quot; and corrections of errors as we may provide to
				you.
					</li>
				</ul>
				<h3>Using the JUVORA&#8482; Guide App</h3>
				<ul>
					<li>You must be 18 or over to accept these Terms and use the JUVORA&#8482; Guide App, the
					Documentation and the Service.
					</li>
					<li>You must comply with all applicable international laws.</li>
					<li>We are giving you personally the right to use the JUVORA&#8482; Guide App, the
					Documentation and the Service. You may not otherwise transfer the JUVORA&#8482;
					Guide App or the Service to someone else, whether for money, for anything else or
					for free. If you sell any device on which the JUVORA&#8482; Guide App is installed, you
					must remove the JUVORA&#8482; Guide App from it.
					</li>
				</ul>
				<h3>Licence Restrictions</h3>
				You agree that you will:
				<ul>
					<li>not sell, sub-license, distribute, display, store, copy, modify, decompile, disassemble,
				reverse engineer, translate, transfer, loan, provide, or otherwise make available, the
				JUVORA&#8482; Guide App, the Documentation or the Service in any form, in whole or in
				part to any person without prior written consent from us except as allowed by these
				Terms;
					</li>
					<li>not use the JUVORA&#8482; Guide App, the Documentation or the Services or any of its
				content to create derivative works or competitive products or compile your own
				database;
					</li>
					<li>comply with all applicable technology control or export laws and regulations that
				apply to the technology used or supported by the JUVORA&#8482; Guide App, the
				Documentation or any Service.
					</li>
				</ul>
				<h3>Acceptable Use Restrictions</h3>
				You must:
				<ul>
					<li>not use the JUVORA&#8482; Guide App, the Documentation or any Service in any unlawful
				manner, for any unlawful purpose, or in any manner inconsistent with these Terms, or
				act fraudulently or maliciously, for example, by hacking into or inserting malicious
				code, such as viruses, or harmful data, into the JUVORA&#8482; Guide App, the
				Documentation any Service or any operating system;
					</li>
					<li>not infringe our intellectual property rights or those of any third party in relation to
				your use of the JUVORA&#8482; Guide App, the Documentation or any Service (to the
				extent that such use is not licensed by these Terms);
					</li>
					<li>not transmit any material that is defamatory, offensive or otherwise objectionable in
				relation to your use of the JUVORA&#8482; Guide App, the Documentation or any Service;
					</li>
					<li>not use the JUVORA&#8482; Guide App, the Documentation or any Service in a way that
				could damage, disable, overburden, impair or compromise our systems or security or
				interfere with other users;
					</li>
					<li>not collect or harvest any information or data from any Service or our systems or
				attempt to decipher any transmissions to or from the servers running any Service.
					</li>
				</ul>
				<h3>Changes to these Terms</h3>
				<p>We change these Terms from time to time. Every time you wish to use the JUVORA&#8482;
				Guide App, please check these Terms to ensure you understand the terms that apply at
				that time.
				</p>
				<h3>Update to the JUVORA&#8482; Guide App and Changes to the Service</h3>
				<p>From time to time we may automatically update the JUVORA&#8482; Guide App, the
				Documentation and change the Service to improve performance, enhance functionality,
				reflect changes or address security issues. Alternatively we may ask you to update the
				JUVORA&#8482; Guide App for these reasons. If you choose not to install such updates or if
				you opt out of automatic updates you may not be able to continue using the JUVORA&#8482;
				Guide App, the Documentation and the Services.
				</p>
				<h3>We may collect technical data about your device</h3>
				<p>By using the JUVORA&#8482; Guide App or any of the Services, you agree to us collecting and
				using technical information about the devices you use the JUVORA&#8482; Guide App on and
				related software, hardware and peripherals to improve our products and to provide any
				Services to you.
				</p>
				<h3>We may collect location data (but can you turn location services off)</h3>
				<p>Certain Services will make use of location data sent from your devices. You can turn off
				this functionality at any time by turning off the location services settings for the
				JUVORA&#8482; Guide App on the device. If you use this Service, you consent to us and our
				affiliates&#39; and licensees&#39; transmission, collection, retention, maintenance, processing and
				use of your location data and queries to provide and improve location-based and road
				traffic-based products and services. You may stop us collecting such data at any time by
				turning off the location services settings.
				</p>
				<h3>We are not responsible for other websites you link to</h3>
				<p>The JUVORA&#8482; Guide App, the Documentation or any Service may contain links to other
				independent websites which are not provided by us. Such independent sites are not
				under our control, and we are not responsible for and have not checked and approved
				their content or their privacy policies (if any). You will need to make your own
				independent judgement about whether to use any such independent sites.
				</p>
				<h3>Intellectual Property Rights</h3>
				<p>We are the owner or licensee of all intellectual property rights in the JUVORA&#8482; Guide
				App, the Documentation and the Services throughout the world. The rights in the
				JUVORA&#8482; Guide App and the Services are licensed (not sold) to you. You have no
				intellectual property rights in, or to, the JUVORA&#8482; Guide App, the Documentation or the
				Services other than the right to use them in accordance with these Terms. Some content
				and materials accessible via the JUVORA&#8482; Guide App may be protected by intellectual
				property rights around the world.
				</p>
				<h3>Our responsibilities</h3>
				<ul>
					<li><b>We are responsible to you for foreseeable loss and damage caused by us</b>. If we
					fail to comply with these Terms, we are responsible for loss or damage you suffer that
					is a foreseeable result of our breaking these terms or our failing to use reasonable
					care and skill, but we are not responsible for any loss or damage that is not
					foreseeable. Loss or damage is foreseeable if either it is obvious that it will happen or
					if, at the time you accepted these terms, both we and you knew it might happen.
					</li>
					<li>
						<b>We do not exclude or limit in any way our liability to you where it would be
						unlawful to do so
						</b>. This includes liability for death or personal injury caused by our
					negligence or the negligence of our employees, agents or subcontractors or for fraud
					or fraudulent misrepresentation.
					</li>
					<li>
						<b>Limitations to the JUVORA&#8482; Guide App, Documentation and the Services</b>. The
					JUVORA&#8482; Guide App, the Documentation and the Services are provided for general
					education and training purposes only and for internal personal use. They do not offer
					advice on which you should rely. You must obtain professional or specialist advice
					before taking, or refraining from, any action on the basis of information obtained
					from the JUVORA&#8482; Guide App, the Documentation or the Service. Although we
					make reasonable efforts to update the information provided by the JUVORA&#8482; Guide
					App, the Documentation and the Service, we make no representations, warranties or
					guarantees, whether express or implied, that such information is accurate, complete
					or up to date. Some information may contain opinions of third parties, and we are
					not responsible for these opinions.
					</li>
					<li>
						<b>You use the JUVORA&#8482; Guide App, the Documentation and the Services at your
					own risk
						</b>. We are not liable for decisions you make on reliance on the JUVORA&#8482;
					Guide App, the Documentation or the Services. This includes legal, compliance
					and/or risk management decisions.
					</li>
					<li>
						<b>We are not liable for your business losses</b>. If you use the JUVORA&#8482; Guide App,
					the Documentation or the Services for any commercial, business or resale purpose we
					will have no liability to you for any loss of profit, loss of business, business
					interruption, or loss of business opportunity.
					</li>
					<li>
						<b>When we are liable for damage to your property</b>. If defective digital content that
					we have supplied damages a device or digital content belonging to you, we will either
					repair the damage or pay you compensation. However, we will not be liable for
					damage that you could have avoided by following our advice to apply an update
					offered to you free of charge or for damage that was caused by you failing to
					correctly follow installation instructions or to have in place the minimum system
					requirements advised by us.
					</li>
					<li>
						<b>Check that the JUVORA&#8482; Guide App, the Documentation and the Services are
					suitable for you
						</b>. The JUVORA&#8482; Guide App, the Documentation and the Services
					have not been developed to meet your individual requirements. Please check that
					the facilities and functions of the JUVORA&#8482; Guide App, the Documentation and the
					Services (as described on the available mobile application stores site and in the
					Documentation) meet your requirements.
					</li>
					<li>
						<b>We are not responsible for events outside our control</b>. If our provision of the
					Services or support for the JUVORA&#8482; Guide App, the Documentation or the Services
					is delayed by an event outside our control then we will contact you as soon as
					possible to let you know and we will take steps to minimise the effect of the delay.
					Provided we do this we will not be liable for delays caused by the event.
					</li>
					<li>
						<b>We may suspend or withdraw access to the JUVORA&#8482; Guide App, the
					Documentation or the Services at any time, with or without notice
						</b>.
					Where we do this, we shall have no responsibility or liability to you. The JUVORA&#8482; Guide App is
					made available to you free of charge. We will try and give you reasonable notice of
					any suspension or withdrawal. If we end your rights to use the JUVORA&#8482; Guide App,
					the Documentation and Services:
						<ul>
							<li>You must stop all activities authorised by these Terms, including your use
							of the JUVORA&#8482; Guide App, the Documentation and any Services.
							</li>
							<li>You must delete or remove the JUVORA&#8482; Guide App from all devices in
							your possession and immediately destroy all copies of the JUVORA&#8482;
							Guide App which you have and confirm to us that you have done this.
							</li>
							<li>We may remotely access your devices and remove the JUVORA&#8482; Guide
							App from them and cease providing you with access to the
							Documentation and the Services.
							</li>
						</ul>
					</li>
				</ul>
				<h3>General provisions</h3>
				<ul>
					<li>We may transfer our rights and obligations under these Terms to another
				organisation. We will always tell you in writing if this happens and we will ensure that
				the transfer will not affect your rights under these Terms. You may only transfer your
				rights or your obligations under these Terms to another person if we agree in writing.
					</li>
					<li>These Terms do not give rights to third parties to enforce any term, other than Juvora
				Limited.
					</li>
					<li>Each of the paragraphs of these Terms operates separately. If any court or relevant
				authority decides that any of them are unlawful, the remaining paragraphs will remain
				in full force and effect.
					</li>
					<li>Even if we delay in enforcing any Terms, we can still enforce it later. If we do not insist
				immediately that you do anything you are required to do under these Terms, or if we
				delay in taking steps against you in respect of your breaking these terms, that will not
				mean that you do not have to do those things and it will not prevent us taking steps
				against you at a later date.
					</li>
					<li>These Terms are governed by English law and you can bring legal proceedings in
				respect of the products in the English courts.
					</li>
				</ul>
			</div>
		</Layout>
	);
};

Terms.propTypes = {
	classes: PropTypes.object.isRequired,
	history: PropTypes.object.isRequired
};

export default withStyles(styles)(Terms);



// WEBPACK FOOTER //
// ./src/client/pages/terms/terms-and-conditions.jsx